import { IApplicationState } from '../../../../../../../../types/types';
import { connect } from 'react-redux';
import { ITabDetailsHOCProps } from './types';
import { ITabDetailsEvents, ITabDetailsFields } from '../../components/TabDetails/types';
import { TabDetails } from '../../components/TabDetails/TabDetails';
import { getSectionType } from '../../../../selectors/getSectionType';
import {
    getIsNewFeatureBoardSplitSettings
} from '../../../../../../../../store/model/authUser/selectors/featuresSeen/getIsNewFeatureBoardSplitSettings';
import { Dispatch } from 'react';
import { onSubTabChange } from './events/onSubTabChange';

const mapStateToProps = (
    state: IApplicationState,
    ownProps: ITabDetailsHOCProps
): ITabDetailsFields => {
    const { boardId } = ownProps;
    const sectionType = getSectionType(state, boardId);
    return {
        boardId,
        isNewFeature: getIsNewFeatureBoardSplitSettings(state),
        sectionType,
    }
};

const mapDispatchToProps = (
    dispatch: Dispatch<any>,
): ITabDetailsEvents => {
    return {
        onSubTabChange: () => dispatch(onSubTabChange()),
    };
};

export const TabDetailsHOC = connect(
    mapStateToProps,
    mapDispatchToProps,
)(TabDetails);

TabDetailsHOC.displayName = 'TabDetailsHOC';
